import { useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
import { C } from './frontDeskData';

export const PaymentPanel = ({ patient: p, method, setMethod, done, onCollect, onClose }) => {
  const total = (p.copay.amount || 0);
  const [cashTendered, setCashTendered] = useState(total);
  const [checkNum, setCheckNum] = useState('');

  if (done) return (
    <div style={{ width: 320, borderLeft: '.5px solid #ebebeb', background: '#fff', padding: 16, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 12, flexShrink: 0 }} data-testid="fd-payment-done">
      <CheckCircle2 style={{ width: 24, height: 24, color: C.green }} />
      <p style={{ fontSize: 14, fontWeight: 500, color: C.black }}>Payment collected &mdash; ${total}</p>
      <p style={{ fontSize: 11, color: '#aaa' }}>Receipt sent to {p.demographics?.email || 'patient'}</p>
      <button onClick={onClose} style={{ width: '100%', height: 36, borderRadius: 6, background: C.black, color: '#fff', fontSize: 12, fontWeight: 500, border: 'none', cursor: 'pointer' }}>Done</button>
    </div>
  );

  return (
    <div style={{ width: 320, borderLeft: '.5px solid #ebebeb', background: '#fff', padding: 16, flexShrink: 0, overflowY: 'auto' }} data-testid="fd-payment-panel">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <span style={{ fontSize: 14, fontWeight: 500, color: C.black }}>Collect payment</span>
        <button onClick={onClose} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#aaa' }}><X style={{ width: 14, height: 14 }} /></button>
      </div>
      <p style={{ fontSize: 11, color: '#aaa', marginBottom: 12 }}>{p.name} &middot; Today's visit</p>
      <p style={{ fontSize: 22, fontWeight: 500, color: C.black, marginBottom: 2 }}>Copay due: ${total}</p>
      <p style={{ fontSize: 11, color: '#aaa', marginBottom: 12 }}>Insurance: {p.copay.payer || 'Unknown'}</p>
      <div style={{ height: .5, background: '#f0f0f0', margin: '0 0 10px' }} />
      {/* Financial context */}
      <div style={{ background: '#fef3c7', borderRadius: 6, padding: '6px 9px', fontSize: 10, color: '#854F0B', marginBottom: 14, lineHeight: 1.4 }}>
        &#9888; Collection rates drop 40% after the patient leaves. Collect before checkout.
      </div>
      {/* Payment method */}
      <div style={{ display: 'flex', gap: 4, marginBottom: 14 }}>
        {['card','cash','check'].map(m => (
          <button key={m} onClick={() => setMethod(m)}
            style={{ flex: 1, height: 30, borderRadius: 5, background: method === m ? C.black : '#f5f5f5', color: method === m ? '#fff' : '#555', fontSize: 11, fontWeight: 500, border: 'none', cursor: 'pointer', textTransform: 'capitalize' }}
            data-testid={`fd-pay-method-${m}`}>{m === 'card' ? '\ud83d\udcb3 Card' : m === 'cash' ? '\ud83d\udcb5 Cash' : '\ud83d\udcdd Check'}</button>
        ))}
      </div>
      {method === 'card' && (
        <div>
          <p style={{ fontSize: 11, color: '#555', marginBottom: 10 }}>No card on file &mdash; manual entry required</p>
          <button onClick={onCollect}
            style={{ width: '100%', height: 36, borderRadius: 6, background: C.greenBtn, color: '#fff', fontSize: 12, fontWeight: 500, border: 'none', cursor: 'pointer' }}
            data-testid="fd-charge-card-btn">Charge card &mdash; ${total}</button>
        </div>
      )}
      {method === 'cash' && (
        <div>
          <label style={{ fontSize: 10, color: '#555' }}>Amount tendered</label>
          <input type="number" value={cashTendered} onChange={e => setCashTendered(Number(e.target.value))}
            style={{ width: '100%', height: 32, borderRadius: 5, border: '.5px solid #e0e0e0', padding: '0 8px', fontSize: 12, marginBottom: 6 }}
            data-testid="fd-cash-input" />
          {cashTendered > total && <p style={{ fontSize: 10, color: '#555', marginBottom: 6 }}>Change due: ${cashTendered - total}</p>}
          <button onClick={onCollect}
            style={{ width: '100%', height: 36, borderRadius: 6, background: C.black, color: '#fff', fontSize: 12, fontWeight: 500, border: 'none', cursor: 'pointer' }}
            data-testid="fd-mark-collected-btn">Mark as collected &mdash; ${total}</button>
        </div>
      )}
      {method === 'check' && (
        <div>
          <label style={{ fontSize: 10, color: '#555' }}>Check number</label>
          <input type="text" value={checkNum} onChange={e => setCheckNum(e.target.value)}
            style={{ width: '100%', height: 32, borderRadius: 5, border: '.5px solid #e0e0e0', padding: '0 8px', fontSize: 12, marginBottom: 6 }}
            data-testid="fd-check-input" />
          <button onClick={onCollect}
            style={{ width: '100%', height: 36, borderRadius: 6, background: C.black, color: '#fff', fontSize: 12, fontWeight: 500, border: 'none', cursor: 'pointer' }}
            data-testid="fd-check-collected-btn">Mark as collected &mdash; ${total}</button>
        </div>
      )}
    </div>
  );
};
